import { jsxs, jsx } from "react/jsx-runtime";
function PauseIcon() {
  const size = "24";
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: size,
      height: size,
      viewBox: `0 0 ${size} ${size}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "4", height: "16", x: "5", y: "5", fill: "white" }),
        /* @__PURE__ */ jsx("rect", { width: "4", height: "16", x: "16", y: "5", fill: "white" })
      ]
    }
  );
}
export {
  PauseIcon
};
//# sourceMappingURL=index.js.map
